/* SKINGRAPHICA redesign, Product information and safety. Language switch, sticky bar offset, product spy */
(function () {
  var root = document.querySelector('[data-pi]');
  if (!root) return;
  var KEY = 'sg-pi-lang';
  var panels = [].slice.call(root.querySelectorAll('[data-pi-lang]'));
  var btns = [].slice.call(root.querySelectorAll('[data-pi-set]'));
  var jumps = [].slice.call(root.querySelectorAll('[data-pi-jump]'));
  var chips = [].slice.call(root.querySelectorAll('.pi-chip'));
  var langs = panels.map(function (p) { return p.getAttribute('data-pi-lang'); });
  var cur = root.getAttribute('data-pi-default') || 'en';

  function set(lang, save) {
    if (langs.indexOf(lang) < 0) return;
    cur = lang;
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-pi-lang') !== lang; });
    btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pi-set') === lang ? 'true' : 'false'); });
    jumps.forEach(function (a) { a.setAttribute('href', '#pi-' + a.getAttribute('data-pi-jump') + '-' + lang); });
    if (save) { try { localStorage.setItem(KEY, lang); } catch (e) {} }
    spy();
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var bar = root.querySelector('[data-pi-bar]');
      var before = bar ? bar.getBoundingClientRect().top : 0;
      set(b.getAttribute('data-pi-set'), true);
      /* keep the bar where the reader left it when the leaflet length changes */
      if (bar) { var after = bar.getBoundingClientRect().top; if (Math.abs(after - before) > 1) window.scrollBy(0, after - before); }
    });
  });

  /* start language: a link to a language or a product in a language wins, then the reader's last choice, then the store language */
  var h = (location.hash || '').slice(1).toLowerCase();
  var m = h.match(/^(?:pi-[a-z]+-)?(en|de|fr|es|it|ja|ko|zh-tw)$/);
  var start = m ? m[1] : null;
  if (!start) { try { start = localStorage.getItem(KEY); } catch (e) {} }
  if (start && start !== cur) set(start, false);
  if (m && /^pi-/.test(h)) {
    var t = document.getElementById(h);
    if (t) setTimeout(function () { t.scrollIntoView(); }, 60);
  }

  /* the bar sits just under the site header, whatever the header is doing */
  var hdr = document.querySelector('.sg-hdr-sec') || document.querySelector('header');
  function setTop() {
    var y = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); y = Math.max(0, Math.round(r.bottom)); }
    root.style.setProperty('--pi-top', y + 'px');
  }

  /* underline the product being read */
  function spy() {
    if (!chips.length) return;
    var line = (parseFloat(getComputedStyle(root).getPropertyValue('--pi-top')) || 0) + 140;
    var id = '';
    root.querySelectorAll('[data-pi-lang="' + cur + '"] [data-pi-p]').forEach(function (p) {
      if (p.getBoundingClientRect().top <= line) id = p.getAttribute('data-pi-p');
    });
    var body = root.querySelector('.pi-body');
    if (body && body.getBoundingClientRect().bottom < line) id = '';
    chips.forEach(function (c) { c.classList.toggle('on', c.getAttribute('data-pi-jump') === id); });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { setTop(); spy(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', setTop);
  setTop(); spy();
})();
